const aaa = [

	{
		path: "kucunList",
		component: () => import("@/views/kucun/kucun/list.vue"),
		meta:{title:'库存信息'},
	}


	
]
export default aaa;